class TuitionCalculator extends HTMLElement {
  constructor() {
    super();
    this.attrs = {};
  }

  connectedCallback() {
    this.init();
  }

  init = async () => {
    /**
     * Set some basic values
     */

    /**
     * When the user changes the program select field, update the tuition, required credits, and fees fields using the data values from the option tag
     *
     */
    const inputs = document.querySelectorAll(".listen-for-input");
    const form = document.querySelector("#tuitionCalculatorWrapper");
    const numInputs = document.querySelectorAll("input[type=number]");

    // Make any input that comes in from the Google sheet blank into a zero.
    numInputs.forEach(function (input) {
      input.addEventListener("change", function (e) {
        if (e.target.value == "") {
          e.target.value = 0;
        }
      });
    });

    // Whenever any input changes, update the tuition calculator's input values
    inputs.forEach((input) => {
      input.addEventListener("input", () => {
        this.updateInput();
      });
    });

    // When the tuition calculator form is submitted, update the output
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.updateOutput();
      document.getElementById("tuitionCalculator-output").scrollIntoView();
    });
  };

  // Helper function to format numbers as US dollars
  dollarUSLocale(value, prepend) {
    let dollarUSLocale = Intl.NumberFormat("en-US");
    return (prepend ? prepend : "") + dollarUSLocale.format(value);
  }

  /**
   * Primary function to update the tuition calculator's inputs
   * @param {string} program
   */
  updateInput() {
    // Get the selected program
    let program = this.querySelector("#tuitionCalculator-input-program")
      .options[
      this.querySelector("#tuitionCalculator-input-program").selectedIndex
    ];

    // Set up the program data from data values on the selected option tag
    let programData = program.dataset;
    let programAma = programData.ama;
    let degreeType = programData.degreeType;
    let maxTransferCredits = programData.maxTransferCredits;
    let requiredCredits = parseInt(programData.requiredCredits);
    let costPerCreditHour = parseInt(programData.costPerCreditHour);
    let tuition = parseInt(requiredCredits) * parseInt(costPerCreditHour);

    // Un-disable user-input fields
    let inputs = document.querySelectorAll(".listen-for-input");
    inputs.forEach((input) => {
      input.disabled = false;
      input.parentNode.classList.remove("input-group-disabled");
    });

    // Update input fields
    this.updateRequiredCreditsInput(requiredCredits);
    this.updateTuitionInput(tuition);
    this.updateTransferCreditsInput(maxTransferCredits);
    this.updateAmaInput(programAma);

    // Update help text
    this.updateDegreeTypeHelp(programData["tooltipProgram"]);
    this.updateRequiredCreditsHelp(programData["tooltipRequiredCredits"]);
    this.updateTransferCreditsHelp(programData["tooltipTransferCredits"]);
    this.updateBooksHelp(programData["tooltipBooks"]);
    this.updateOtherHelp(programData["tooltipOther"]);
    this.updateFederalAidHelp(programData["tooltipFederalAid"]);
    this.updateScholarshipsHelp(programData["tooltipScholarships"]);
    this.updatePersonalGiftsHelp(programData["tooltipPersonalGifts"]);

    // Unhide popovers
    let popovers = document.querySelectorAll(".info");
    popovers.forEach((popover) => {
      popover.classList.remove("info-hidden");
    });
  }

  /**
   * Function to calculate the output of the tuition calculator
   */
  updateOutput() {
    // Get the selected program
    let program = this.querySelector("#tuitionCalculator-input-program")
      .options[
      this.querySelector("#tuitionCalculator-input-program").selectedIndex
    ];

    // Set up the program data from data values on the selected option tag
    let programData = program.dataset;
    let programTitle = programData.title;
    let panelUx = programData.panelUx;
    let panelContent = programData.panelContent;
    let disclaimerText = programData.disclaimerText;
    let panelLink = programData.panelLink;
    let requiredCredits = parseInt(programData.requiredCredits);
    let transferCredits = parseInt(
      this.querySelector("#tuitionCalculator-input-transferCredits").value
    );
    let costPerCreditHour = parseInt(programData.costPerCreditHour);
    let books = parseInt(
      this.querySelector("#tuitionCalculator-input-books").value
    );
    let other = parseInt(
      this.querySelector("#tuitionCalculator-input-other").value
    );
    let federalAid = parseInt(
      this.querySelector("#tuitionCalculator-input-federalAid").value
    );
    let scholarships = parseInt(
      this.querySelector("#tuitionCalculator-input-scholarships").value
    );
    let personalGifts = parseInt(
      this.querySelector("#tuitionCalculator-input-personalGifts").value
    );
    let adjustedCredits = parseInt(requiredCredits) - parseInt(transferCredits);
    let adjustedTuition =
      parseInt(adjustedCredits) * parseInt(costPerCreditHour);

    this.updatePanelUx(panelUx);
    this.updatePanelContent(panelContent);
    this.updateDisclaimerPanelContent(disclaimerText);
    this.updatePanelLink(panelLink);
    this.updateProgramOutput(programTitle);
    this.updateRequiredCreditsOutput(requiredCredits);
    this.updateTransferCreditsOutput(transferCredits);
    this.updateTotalCreditsOutput(adjustedCredits);
    this.updateTuitionOutput(adjustedTuition);
    this.updateBooksOutput(books);
    this.updateOtherOutput(other);
    this.updateTotalExpensesOutput(adjustedTuition, books, other);
    this.updateFederalAidOutput(federalAid);
    this.updateScholarshipsOutput(scholarships);
    this.updatePersonalGiftsOutput(personalGifts);
    this.updateTotalCostOutput(
      adjustedTuition,
      books,
      other,
      federalAid,
      scholarships,
      personalGifts
    );
  }

  /**
   * Return the value of total expenses: tuitionPrice plus fees plus books plus other
   *
   */
  getTotalExpenses(tuition, books, other) {
    return parseInt(tuition) + parseInt(books) + parseInt(other);
  }

  /**
   * Return the value of total aid: federalAid + scholarships + personalGifts
   */
  getTotalAid(federalAid, scholarships, personalGifts) {
    return (
      parseInt(federalAid) + parseInt(scholarships) + parseInt(personalGifts)
    );
  }

  /** ////////////////////////////////////////////////////////////////////////////
   *
   * Inputs
   *
   * ////////////////////////////////////////////////////////////////////////////
   */

  /**
   * Function to set the value of requiredCredits to the passed in value
   */
  updateRequiredCreditsInput(value) {
    this.querySelector("#tuitionCalculator-input-requiredCredits").value =
      value;
  }

  /**
   * Function to set the value of ama to the passed in value
   */
  updateAmaInput(value) {
    this.querySelector("#tuitionCalculator-input-ama").value = value;
  }

  /**
   * Function to update the value of tuition to the passed in value
   */
  updateTuitionInput(value) {
    this.querySelector("#tuitionCalculator-input-tuition").value =
      this.dollarUSLocale(value);
  }

  /**
   * Function to update the max value of the transferCredits field
   */
  updateTransferCreditsInput(value) {
    let input = this.querySelector("#tuitionCalculator-input-transferCredits");

    if (value == 0) {
      input.disabled = true;
      input.parentNode.classList.add("input-group-disabled");
    } else {
      input.disabled = false;
      input.parentNode.classList.remove("input-group-disabled");
    }

    input.max = parseInt(value);
  }

  /** ////////////////////////////////////////////////////////////////////////////
   *
   * Helptext
   *
   * ////////////////////////////////////////////////////////////////////////////
   */

  /**
   * Function to update the degreeType helptext
   */
  updateDegreeTypeHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-program");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /**
   * Function to update the requiredCredits helptext
   */
  updateRequiredCreditsHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-requiredCredits");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /**
   * Function to update the transferCredits helptext
   */
  updateTransferCreditsHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-transferCredits");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /**
   *
   * Function to update the books helptext
   */
  updateBooksHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-books");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /**
   * Function to update the other helptext
   */
  updateOtherHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-other");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /**
   * Function to update the federalAid helptext
   */
  updateFederalAidHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-federalAid");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /**
   * Function to update the scholarships helptext
   */
  updateScholarshipsHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-scholarships");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /**
   * Function to update the personalGifts helptext
   */
  updatePersonalGiftsHelp(value) {
    let el = this.querySelector("#tuitionCalculator-help-personalGifts");
    let content = value;
    el.setAttribute("data-bs-content", content);
    el.querySelector(".sr-only").textContent = content;
  }

  /** ////////////////////////////////////////////////////////////////////////////
   *
   * Outputs
   *
   * ////////////////////////////////////////////////////////////////////////////
   */

  /**
   * Function to update panelUx
   */
  updatePanelUx(value) {
    let panels = this.querySelectorAll(".tuitionCalculator-panel");
    let panel0 = this.querySelector("#tuitionCalculator-output-calculated");
    let panel1 = this.querySelector("#tuitionCalculator-output-message");

    panels.forEach((panel) => {
      panel.classList.add("d-none");
    });

    if (value == 0) {
      panel0.classList.remove("d-none");
      panel0.classList.add("d-block");
    } else if (value == 1) {
      // remove class d-none from panel1
      panel1.classList.remove("d-none");
      panel1.classList.add("d-block");
    }
  }

  /**
   * Function to update panel content ('disclaimer')
   */
  updatePanelContent(value) {
    this.querySelector("#tuitionCalculator-output-content").innerHTML = value;
  }
  updateDisclaimerPanelContent(value) {
    this.querySelector("#tuitionCalculator-disclaimer-text").innerHTML = value;
  }

  /**
   * Function to update panel link
   */
  updatePanelLink(value) {
    this.querySelector("#tuition-calculator-callToActionLink").href =
      "/programs/" + value;
  }

  /**
   * Function to update the text of program to the value of the selected option in the program select field
   */
  updateProgramOutput(program) {
    // Update the content of #tuitionCalculator-output-program to the value of program
    this.querySelector("#tuitionCalculator-output-program").textContent =
      program;
  }

  /**
   * Function to update the text of required credits
   */
  updateRequiredCreditsOutput(value) {
    this.querySelector(
      "#tuitionCalculator-output-requiredCredits"
    ).textContent = value;
  }

  /**
   * Function to update the text of transfer credits to the value of the #tuitionCalculator-input-transferCredits input
   */
  updateTransferCreditsOutput(value) {
    this.querySelector(
      "#tuitionCalculator-output-transferCredits"
    ).textContent = value;
  }

  /**
   * Function to update the text of total credits with the value of the passed value
   */
  updateTotalCreditsOutput(value) {
    this.querySelector("#tuitionCalculator-output-totalCredits").textContent =
      value;
  }

  /**
   * Function to update the text of tuition to the value of the #tuitionCalculator-input-tuition input
   */
  updateTuitionOutput(value) {
    this.querySelector("#tuitionCalculator-output-tuition").textContent =
      this.dollarUSLocale(value, "$");
  }

  /**
   * Function to update the text of books to the value of the #tuitionCalculator-input-books input
   */
  updateBooksOutput(value) {
    this.querySelector("#tuitionCalculator-output-books").textContent = value;
  }

  /**
   * Function to update the text of books to the value of the #tuitionCalculator-input-books input
   */
  updateOtherOutput(value) {
    this.querySelector("#tuitionCalculator-output-other").textContent = value;
  }

  /**
   * Function to update the value of totalExpenses to the sum of tuition, fees, books, and other
   */
  updateTotalExpensesOutput(tuition, books, other) {
    let totalExpenses = this.getTotalExpenses(tuition, books, other);
    // Update the content of #tuitionCalculator-output-totalExpenses to the value of totalExpenses
    this.querySelector("#tuitionCalculator-output-totalExpenses").textContent =
      this.dollarUSLocale(totalExpenses, "$");
  }

  /**
   * Function to update the text of federalAid
   */
  updateFederalAidOutput(value) {
    this.querySelector("#tuitionCalculator-output-federalAid").textContent =
      value;
  }

  /**
   * Function to update the text of scholarships
   */
  updateScholarshipsOutput(value) {
    this.querySelector("#tuitionCalculator-output-scholarships").textContent =
      value;
  }

  /**
   * Function to update the text of personalGifts
   */

  updatePersonalGiftsOutput(value) {
    this.querySelector("#tuitionCalculator-output-personalGifts").textContent =
      value;
  }

  /**
   * Function to update the value of totalCost to estimatedTotalExpenses minus totalAid
   */
  updateTotalCostOutput(
    tuition,
    books,
    other,
    federalAid,
    scholarships,
    personalGifts
  ) {
    let totalExpenses = this.getTotalExpenses(tuition, books, other);
    let totalAid = this.getTotalAid(federalAid, scholarships, personalGifts);
    let totalCost = this.dollarUSLocale(totalExpenses - totalAid, "$");
    // Update the content of #tuitionCalculator-output-totalCost to the value of totalCost
    this.querySelector("#tuitionCalculator-output-totalCost").textContent =
      totalCost;
  }
}

if ("customElements" in window) {
  window.customElements.define("tuition-calculator", TuitionCalculator);
}
